import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { OtdPricingMessage, StyledInfoIcon } from '../Common.styles'
import ProductTable from './components/ProductTable'
import Services from './components/Services'
import QuoteSummary from 'components/common/QuoteSummary'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import EmptyQuoteMessage from './components/EmptyQuoteMessage'
import { OTDP_MESSAGE } from 'constant'
import styled from 'styled-components'
import StoreDetails from 'components/common/QuoteSummary/components/StoreDetails'
import TPPBanner from './../BOTProductAndServicesQuote/components/TPPBanner'
import BreadPaymentsBanner from 'components/common/BreadPayments/BreadPaymentsBanner'

const ProductAndServicesQuoteFieldComponent = ({
  currentStore,
  freeAligmentTooltip,
  freeAlignmentCheckDisabled,
  hasProductsOrServices,
  proceedErrors,
  showTPPBanner,
  handleShowTPPModal,
  handleCloseTPPBanner,
  quotedItemAndServices: {
    products = [],
    services = [],
    installationKits = [],
    appliedPromotions = [],
    otdPricingToolTipMessage,
    inActiveSkuMessage,
    quoteSummary
  },
  onRequestApptClick,
  paymentOptionsBannerTemplate
}) =>
  <Container>
    <Media.Mobile>
      <StoreDetailsBlock>
        <StoreDetails
          currentStore={ currentStore || {} } />
      </StoreDetailsBlock>
    </Media.Mobile>
    <ProductsAndServices>
      { showTPPBanner && Boolean(products.length) &&
        <TPPBanner
          onInfoClick={ handleShowTPPModal }
          onCloseClick={ handleCloseTPPBanner } />
      }
      <ProductTable
        products={ products }
        installationKits={ installationKits }
        freeAligmentTooltip={ freeAligmentTooltip }
        freeAlignmentCheckDisabled={ freeAlignmentCheckDisabled }
        inActiveSkuMessage={ inActiveSkuMessage }
        otdPricingToolTipMessage={ otdPricingToolTipMessage }
        enableEdit />
      {
        hasProductsOrServices ?
          <Fragment>
            <Services services={ services } enableEdit />
            <Media.Mobile>
              <Summary
                appliedPromotions={ appliedPromotions }
                quoteSummary={ quoteSummary }
                currentStore={ currentStore || {} }
                showStoreSection
                handleProceed={ onRequestApptClick }
                services={ services }
                isCheckout />
            </Media.Mobile>
            {
              Boolean(products.length) &&
              <Fragment>
                <OtdPricingMessage>
                  <StyledInfoIcon asset="icon-info" alt="" />
                  <div>{ OTDP_MESSAGE }</div>
                </OtdPricingMessage>
                <BreadPaymentsBanner
                  content={ paymentOptionsBannerTemplate }
                  totalPrice={ quoteSummary.estimatedTotal } />
              </Fragment>
            }
          </Fragment> :
          <EmptyQuoteMessage />
      }
    </ProductsAndServices>
  </Container>

ProductAndServicesQuoteFieldComponent.propTypes = {
  currentStore: PropTypes.shape(),
  freeAligmentTooltip: PropTypes.shape(),
  freeAlignmentCheckDisabled: PropTypes.bool,
  handleCloseTPPBanner: PropTypes.func,
  handleShowTPPModal: PropTypes.func,
  hasProductsOrServices: PropTypes.bool,
  onRequestApptClick: PropTypes.func,
  paymentOptionsBannerTemplate: PropTypes.string,
  proceedErrors: PropTypes.arrayOf(PropTypes.string),
  quotedItemAndServices: PropTypes.shape({
    freeAligmentTooltip: PropTypes.shape(),
    timeSlot: PropTypes.shape(),
    tppToolTipMessage: PropTypes.string,
    products: PropTypes.arrayOf(PropTypes.shape()),
    services: PropTypes.arrayOf(PropTypes.shape()),
    installationKits: PropTypes.arrayOf(PropTypes.shape()),
    inActiveSkuMessage: PropTypes.string,
    appliedPromotions: PropTypes.arrayOf(PropTypes.shape()),
    otdPricingToolTipMessage: PropTypes.string,
    quoteSummary: PropTypes.shape({
      estimatedTotal: PropTypes.number,
      instantSavings: PropTypes.number,
      productAndService: PropTypes.number
    })
  }),
  showTPPBanner: PropTypes.bool
}

export default ProductAndServicesQuoteFieldComponent

const Container = styled.div`
  ${Media.desktop`
    display: flex;
  `}
`

const ProductsAndServices = styled.div`
  flex: 1 2 70%;

  .product-item-exit {
    max-height: 670px;
    opacity: 1;
  }

  .product-item-exit-active {
    max-height: 0;
    opacity: 0;
    transition: max-height 1000ms ease-in, opacity 1000ms ease-in;
  }
`

const Summary = styled(QuoteSummary)`
  ${Media.desktop`
    flex: 0 0 auto;
    padding-left: 30px;
    align-self: flex-start;
    margin-left: auto;
    position: -webkit-sticky;
    position: sticky;
    top: 160px;
    width: 370px;
  `}
`
const StoreDetailsBlock = styled.div`
  margin-bottom: 15px;
  padding: 15px;
  border: 1px solid ${Theme.colors.light_grey};
`
